import clsx from 'clsx';
import { ReactElement, useState } from 'react';

import './TabGroup.scss';

interface TabGroupProps {
  tabs: { label: string; component: ReactElement }[];
  initialActiveTabIndex?: number;
}

export default function TabGroup({ tabs, initialActiveTabIndex = 0 }: TabGroupProps) {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(initialActiveTabIndex);

  return (
    <div className="tab-group">
      <div className="tabs-container mb-12">
        {tabs.map((tab, index) => (
          <button
            key={tab.label}
            className={clsx('tab', index === activeTabIndex && 'active')}
            onClick={() => {
              setActiveTabIndex(index);
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {tabs.length > 0 && tabs[activeTabIndex].component}
    </div>
  );
}
